if (!window.location.pathname.includes('/products/')) {
  console.log('[Dolfin Video] Skipping video logic: not on a product page');
} else {
  (function waitForGalleryAndInit() {
    const hasSwiper = document.querySelector('.product-image__images-ct .swiper-wrapper');
    const hasStaticGallery = document.querySelector('.product-image__images-ct ul');
    if (!hasSwiper && !hasStaticGallery) {
      setTimeout(waitForGalleryAndInit, 150);
      return;
    }
    console.log('[Dolfin Video] ✅ Detected gallery. Initializing...');
    initializeVideoSupport();
  })();

  function initializeVideoSupport() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && video.paused) {
          video.play().catch(() => {});
        }
      });
    }, { threshold: 0.75 });

    function decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }

    function isAlreadyHydrated(slide) {
      return slide.querySelector('video') && slide.querySelector('.video-wrapper');
    }

    function cleanSlide(slide) {
      while (slide.firstChild) slide.removeChild(slide.firstChild);
    }

    function hydrateSlide(slide) {
      if (!slide || isAlreadyHydrated(slide)) return;
      const decoded = decodeHtml(slide.innerHTML || '');
      const videoHTML = decoded.match(/<video[\s\S]*?<\/video>/)?.[0];
      if (!videoHTML) return;

      const temp = document.createElement('div');
      temp.innerHTML = videoHTML;
      const video = temp.querySelector('video');
      if (!video) return;

      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'auto');
      video.muted = true;
      video.style.cssText = 'width:100%; height:100%; object-fit:cover; display:block;';

      const wrapper = document.createElement('div');
      wrapper.className = 'video-wrapper';
      wrapper.style.cssText = 'padding:132.14% 0 0 0; position:relative;';
      wrapper.appendChild(video);

      cleanSlide(slide);
      slide.appendChild(wrapper);
      observer.observe(video);
    }

    function hydrateAllSlides() {
      document.querySelectorAll('.swiper-slide, .product-image__images-ct li').forEach(hydrateSlide);
    }

    function setupThumbnails() {
  document.querySelectorAll('.product-thumbnails-wrapper li').forEach(li => {
    const anchor = li.querySelector('a');
    if (!anchor) return;

    const decoded = decodeHtml(anchor.innerHTML || '');
    const videoHTML = decoded.match(/<video[\s\S]*?<\/video>/)?.[0];
    if (!videoHTML) return;

    const existingWrapper = anchor.querySelector('.thumb-video-wrapper');
    if (existingWrapper) existingWrapper.remove();

    const img = anchor.querySelector('img');
    if (img) img.style.display = 'none';

    // --- Create wrapper and insert video ---
    const wrapper = document.createElement('div');
    wrapper.className = 'thumb-video-wrapper';
    wrapper.style.cssText = 'position:relative;width:100%;height:auto;overflow:hidden;';
    wrapper.innerHTML = videoHTML.replace(
      '<video',
      '<video muted playsinline preload="metadata" style="width:100%;height:auto;pointer-events:none;visibility:hidden;"'
    );

    anchor.appendChild(wrapper);
    const video = wrapper.querySelector('video');
    if (!video) return;

    // --- Seek to 3s (or halfway if shorter) ---
    const showStaticFrame = () => {
      try {
        const target = video.duration > 3 ? 3 : Math.min(1, (video.duration || 1) / 2);
        const onSeeked = () => {
          requestAnimationFrame(() => {
            video.pause();
            video.style.visibility = 'visible';
          });
          video.removeEventListener('seeked', onSeeked);
        };
        video.addEventListener('seeked', onSeeked, { once: true });
        video.currentTime = target;
      } catch (e) {
        console.warn('[Dolfin Thumb] seek failed:', e);
        video.style.visibility = 'visible';
      }
    };

    if (video.readyState >= 1) {
      showStaticFrame();
    } else {
      video.addEventListener('loadedmetadata', showStaticFrame, { once: true });
      try { video.load(); } catch (_) {}
    }

    // --- Determine overlay type ---
    const isManualPlay =
      video.getAttribute('data-autoplay') === 'false' ||
      video.hasAttribute('controls') ||
      !video.hasAttribute('autoplay');

    const iconSrc = isManualPlay
      ? "//dev-shop.dolfinswimwear.com/cdn/shop/t/22/assets/icon-play.svg?v=19680"
      : "//dev-shop.dolfinswimwear.com/cdn/shop/t/22/assets/icon-360-whirl.svg?v=113497296442873025331761584782";

    // --- Add overlay ---
    const overlay = document.createElement('div');
    overlay.className = isManualPlay ? 'thumb-video-play-overlay' : 'thumb-video-360-overlay';
    overlay.innerHTML = `<img src="${iconSrc}" alt="${isManualPlay ? 'Play' : '360°'}">`;
    overlay.style.cssText = `
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%,-50%);
      width:35px;
      height:48px;
      z-index:5;
      display:flex;
      align-items:center;
      justify-content:center;
      pointer-events:none;
      opacity:0.9;
    `;

    const icon = overlay.querySelector('img');
    icon.style.cssText = 'width:100%;height:100%;transition:opacity .2s ease;';
    wrapper.appendChild(overlay);
  });
}

    function bindStaticThumbnailClicks() {
      document.querySelectorAll('.product-thumbnails-wrapper li a').forEach(anchor => {
        anchor.addEventListener('click', () => {
          setTimeout(() => {
            const targetIndex = anchor.getAttribute('data-index');
            const targetSlide = document.querySelector(`.product-image__images-ct li[data-index="${targetIndex}"]`);
            if (targetSlide) {
              hydrateSlide(targetSlide);
              const video = targetSlide.querySelector('video');
              if (video) {
                video.play().catch(err => {
                  console.warn('[Dolfin Video] Desktop click play error:', err);
                });
              }
            }
          }, 150);
        });
      });
    }

    function waitForSwiper() {
      const swiper = getSwiperInstance();
      if (!swiper || !swiper.initialized) {
        setTimeout(waitForSwiper, 150);
        return;
      }

      console.log('[Dolfin Video] Swiper ready ✅');
      swiper.on('slideChangeTransitionEnd', () => {
        document.querySelectorAll('video').forEach(v => v.pause());
        hydrateAllSlides();
        setupThumbnails();
        const activeVideo = document.querySelector('.swiper-slide-active video');
        if (activeVideo) {
          activeVideo.play().catch(err => {
            console.warn('[Dolfin Video] Playback failed:', err);
          });
        }
      });

      hydrateAllSlides();
      setupThumbnails();

      setTimeout(() => {
        requestAnimationFrame(() => {
          const firstVideo = document.querySelector('.swiper-slide-active video');
          if (firstVideo) {
            firstVideo.play().catch(err => {
              console.warn('[Dolfin Video] Initial video play failed:', err);
            });
          }
        });
      }, 250);
    }

    const swiperWrapper = document.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      const mutationObs = new MutationObserver(() => {
        hydrateAllSlides();
        setupThumbnails();
      });
      mutationObs.observe(swiperWrapper, { childList: true, subtree: true });
    }

    hydrateAllSlides();
    setupThumbnails();
    bindStaticThumbnailClicks();
    waitForSwiper();

    ['resize', 'orientationchange'].forEach(evt =>
      window.addEventListener(evt, hydrateAllSlides)
    );
  }

  function getSwiperInstance() {
    return window.swiper || document.querySelector('.swiper')?.swiper || null;
  }
}
